import { Admin } from "../admins/Admin";
import { Doctor } from "../doctors/Doctor";

export const MyAccountFormTemplate = Object.freeze({
  sections: [
    {
      title: "Detalles",
      size: 1 / 2,
      compact: true,
      inputs: [Admin.name, Admin.last_name],
    },
    {
      size: 1 / 2,
      compact: true,
      inputs: [
        Admin.email,
        /* Admin.super */ //New MyAccount page for all types of users, we don't need this field
      ],
    },
  ],
});



//NEW @alreylz
export const DoctorProfileFormTemplate = Object.freeze({
  sections: [
    {
      title: "Detalles",
      size: 1 / 2,
      compact: true,
      inputs: [Admin.name, Doctor.last_name],
    },
    {
      size: 1 / 2,
      compact: true,
      inputs: [
        Admin.email,
        Doctor.description,
        Doctor.formation,
        // Doctor.telephone_number,
        Doctor.speciality,
        Doctor.direction_facturation
      ],
    },
  ],
});
export const ChangePassFormTemplate = Object.freeze({
  sections: [
    {
      title: "Modificar contraseña",
      size: 1 / 2,
      compact: true,
      inputs: [Admin.password, Admin.passwordVerification],
    },
  ],
});
